export const importAsset = (path) => {
    try {
        const req = require.context('assets/', true, /^\.\/.*\.svg$/);
        return req(path);
    } catch (e) {
        console.error('Error: ' + e);
    }
};